<template>
  <v-dialog v-if="hasSupportTicket" class="support-dialog-container" v-model="dialogVisible">
    <template v-slot:activator="{ on, attrs }">
      <v-btn height="36px" class="support-activator-btn" icon v-bind="attrs" v-on="on">
        <v-icon v-if="ticket?.quelpId" color="blue">mdi-alpha-q-box</v-icon>
        <v-icon v-else color="warning">mdi-headset</v-icon>
      </v-btn>
    </template>
    <div class="support-dialog-container__content">
      <StateDisplay v-if="loading" :loading="loading" />
      <SupportTicketsCard v-else-if="ticket && !loading" :ticket="ticket" />
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import SupportTicketsCard from "@/components/Support/SupportTicketsCard";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../fb";
import StateDisplay from "@/components/StateDisplay";

export default {
  name: "SupportDialog",
  components: { StateDisplay, SupportTicketsCard },
  data() {
    return {
      dialogVisible: false,
      loading: false
    };
  },
  watch: {

  },
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["ticketsActive"]),

    ticket() {
      return this.ticketsActive.find((ticket) => {
        return ticket.orderUid + '' === this.orderId + '';
      }) || null;
    },

    hasSupportTicket() {
      return this.ticket !== null;
    },
  },
  methods: {
  }
}
</script>


<style lang="scss" scoped>
.support-activator-btn {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px;
  background-color: #282828;
}

.support-dialog-container {
  &__content {
    background-color: white;

   }
}
</style>
